// @flow

import type { ApiExecutorType } from 'types/ApiExecutorType';

function ApiExecutor(executor: Object): ApiExecutorType {
  return { getWithHeader, get, put, post, del };

  function handle(request) {
    return request.then(({ data }) => {
      return data;
    });
  }

  function handleWithHeader(request) {
    return request.then(data => {
      return {
        body: data.data,
        headers: data.headers
      };
    });
  }

  function getWithHeader(url, params, config) {
    return handleWithHeader(executor.get(url, params, config));
  }

  function get(url, params, config) {
    return handle(executor.get(url, params, config));
  }

  function put(url, body) {
    return handle(executor.put(url, body));
  }

  function post(url, body, config) {
    return handle(executor.post(url, body, config));
  }

  function del(url) {
    return handle(executor.delete(url));
  }
}

export default ApiExecutor;
